export const AUTH = 'AUTH'
export const OPEN_ROUTE = '*'
export const ADMIN = 'ADMIN'
export const USER = 'USER'
